import React, { useState } from 'react';
import styled from 'styled-components';
import DailyResult from './DailyResult';
import DailyResultthreed from './DailyResultthreed';
import Live from './Live';
import Livethreed from './Livethreed';

const Ul = styled.ul`
    display: grid;
    grid-template-columns: auto auto;
`

const ListTab = styled.li`
    background-color: #FFF;
    padding: 5px;
    border-radius: 10px;
    border: 1px solid #FFF;
    user-select: none;
    margin: 5px;
    color: #000;
    background-color: #e3e3e3;
    text-align: center;
    cursor: pointer;
`

const Home = () => {
  const [twod,setTwod] = useState(true);
  const [threed,setThreed] = useState(false);

  const twodHandler = () => {
      setTwod(true);
      setThreed(false);
  };
  const threedHandler = () => {
      setThreed(true);
      setTwod(false);
  }

  return (
    <>
      {
        twod ?
        <Live />:
        <Livethreed />
      }
      <Ul>
        <ListTab onClick={twodHandler}
            style={{
              color: twod ? '#FFF':"#000",
              backgroundColor: twod ? "#2993CF":"#e3e3e3"
            }}
            >
                2D
            </ListTab>
            <ListTab onClick={threedHandler}
            style={{
              color: threed ? '#FFF':"#000",
              backgroundColor: threed ? "#2993CF":"#e3e3e3"
            }}
            >
                3D
            </ListTab>
      </Ul>
      {
        twod ?
        <DailyResult />:
        <DailyResultthreed />
      }

     
    </>
  )
}

export default Home
